import { motion } from "framer-motion";
import { useI18n } from "../../i18n";

const HERO_IMG =
  "https://images.unsplash.com/photo-1771842712919-3e7687ccabd6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxtZWRpdGVycmFuZWFuJTIwc2VhJTIwc3VucmlzZSUyMGNvYXN0bGluZXxlbnwwfHx8fDE3Nzg1MDIzMTR8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const { t } = useI18n();
  return (
    <section id="top" className="relative h-[100svh] min-h-[640px] w-full overflow-hidden" data-testid="hero-section">
      <motion.div
        initial={{ scale: 1.08, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 2.4, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0"
      >
        <img
          src={HERO_IMG}
          alt="Mediterranean sunrise"
          className="h-full w-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/30 via-charcoal/10 to-charcoal/55" />
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal/25 to-transparent" />
      </motion.div>

      <div className="relative z-10 h-full flex flex-col justify-end pb-16 md:pb-24 px-6 md:px-12 lg:px-20">
        <motion.span
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.6 }}
          className="text-ivory/85 text-[0.72rem] tracking-luxe uppercase mb-6 md:mb-8"
          data-testid="hero-eyebrow"
        >
          {t.hero.eyebrow}
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.4, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif-display text-ivory text-[15vw] sm:text-[12vw] md:text-[10vw] lg:text-[8.5vw] leading-[0.92]"
          data-testid="hero-title"
        >
          <span className="block">{t.hero.title_a}</span>
          <span className="block italic font-light pl-[10%] md:pl-[14%]">{t.hero.title_b}</span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 1.4 }}
          className="mt-8 md:mt-12 flex flex-col md:flex-row md:items-end md:justify-between gap-6 md:gap-12"
        >
          <p className="font-serif italic text-ivory/90 text-xl md:text-2xl max-w-md leading-snug">
            {t.hero.sub}
          </p>

          <a
            href="#intro"
            data-testid="hero-cta"
            className="group inline-flex w-fit items-center gap-3 bg-ivory/95 text-charcoal px-8 py-4 text-[0.72rem] tracking-luxe uppercase shadow-[0_8px_30px_rgba(0,0,0,0.12)] hover:bg-ivory hover:shadow-[0_12px_40px_rgba(0,0,0,0.18)] transition-all duration-700"
          >
            {t.hero.cta}
            <span className="block w-6 h-px bg-charcoal transition-all duration-700 group-hover:w-10" />
          </a>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.4, delay: 2 }}
        className="absolute bottom-6 right-6 md:bottom-10 md:right-12 text-ivory/70 text-[0.65rem] tracking-luxe uppercase rotate-90 origin-bottom-right hidden md:block"
      >
        Sardegna · Costa Orientale
      </motion.div>
    </section>
  );
}
